// DS COLORS
export const PRIMARY_BLACK = '#121212';
export const PRIMARY_PAYMENT_DEFAULT = '#008859';
export const PRIMARY_PAYMENT_LIGHT = '#3CAB6D';
export const PRIMARY_SEND_DEFAULT = '#0049C4';
export const PRIMARY_SEND_DARK = '#0D3F92';
export const PRIMARY_ORANGE_DARK = '#FF5524';
export const PRIMARY_REWARDS_DEFAULT = '#FFC738';
export const SECONDARY_GRAY_8 = '#ECECEC';
export const SECONDARY_GRAY_20 = '#D0D0D0';
export const SECONDARY_GRAY_40 = '#929292';
export const SECONDARY_GRAY_80 = '#414141';
export const SECONDARY_PAYMENT_10 = '#0088591A'
export const TERTIARY_PURPLE_DARK = '#A376FF';


///////////////////////////////////////////////////////////////

export const TRANSPARENT = 'transparent';
export const BLACK = '#000000';
export const WHITE = '#FFFFFF';
export const PRIMARY_BUTTON = '#2E3849';
export const PRIMARY_DARK = '#0783D3';
export const SECONDARY_BUTTON = '#263144';
export const BODY_TEXT = '#212529';
export const BLACK_PRIMARY_OPACITY_5 = '#1212120D';
export const BLACK_SECONDARY = '#47525D';
export const GRAY_PRIMARY = '#A8A8A8';
export const GRAY_SECONDARY = '#F1F1F1';
export const GRAY_THIRD = '#CCCCCC';
export const GRAY_FOURTH = '#FAFAFA';
export const GRAY_FIFTH = '#A0A0A0';
export const GRAY_BUTTON = '#E6E6E6';
export const GRAY_ALTERNATIVE = '#F8F8F8';
export const GREEN_PRIMARY = '#06814D';
export const GREEN_SECONDARY = '#66E3CA';
export const BLUE_PRIMARY_LIGHT = '#E5EDF9';
export const WARNING = '#D32F2F';
export const PRIMARY_ERROR_LIGHT = '#FFECF2';
export const PRIMARY_ERROR_DARK = '#FD0658';
export const YELLOW_LIGHT = "#FEF4E5";

// Cards
export const CARD_AWAITING_PROMO_WINDOW = '#29B095';
export const CARD_VISIBLE_NOT_APPLICABLE = '#0192B3';
export const CARD_RUNNING = '#4BD382';
export const CARD_FINISHED = SECONDARY_GRAY_20;

// Merchants Dark
export const MERCHANT_DARK1 = '#EBAE10';
export const MERCHANT_DARK2 = '#FE5E5E';
export const MERCHANT_DARK3 = '#F7924A';
export const MERCHANT_DARK4 = '#A376FF';
export const MERCHANT_DARK5 = '#6D6B6B';
export const MERCHANT_DARK6 = '#3395FF';
export const MERCHANT_DARK7 = '#4EB62A';
export const MERCHANT_DARK8 = '#29C6E2';
export const MERCHANT_DARK9 = '#ED72DA';
export const MERCHANT_DARK10 = '#425573';
export const MERCHANT_DARK11 = '#00D0A6';

// Merchants Lights
export const MERCHANT_LIGHT1 = '#FDF7E7';
export const MERCHANT_LIGHT2 = '#FFEFEF';
export const MERCHANT_LIGHT3 = '#FDE9DB';
export const MERCHANT_LIGHT4 = '#F6F1FF';
export const MERCHANT_LIGHT5 = '#F0F0F0';
export const MERCHANT_LIGHT6 = '#EBF4FF';
export const MERCHANT_LIGHT7 = '#EDF8EA';
export const MERCHANT_LIGHT8 = '#EAF9FC';
export const MERCHANT_LIGHT9 = '#FDF1FB';
export const MERCHANT_LIGHT10 = '#ECEEF1';
export const MERCHANT_LIGHT11 = '#E5FAF6';

// Layout
export const LAYOUT_BACKGROUND = '#263144';
export const LAYOUT_BACKGROUND_SELECTED_TAB = '#ffffff1f';

export const MERCHANTS_PALETTE = [
  WHITE,
  BLACK,
  MERCHANT_DARK1,
  MERCHANT_DARK2,
  MERCHANT_DARK3,
  MERCHANT_DARK4,
  MERCHANT_DARK5,
  MERCHANT_DARK6,
  MERCHANT_DARK7,
  MERCHANT_DARK8,
  MERCHANT_DARK9,
  MERCHANT_DARK10,
  MERCHANT_DARK11,
  MERCHANT_LIGHT1,
  MERCHANT_LIGHT2,
  MERCHANT_LIGHT3,
  MERCHANT_LIGHT4,
  MERCHANT_LIGHT5,
  MERCHANT_LIGHT6,
  MERCHANT_LIGHT7,
  MERCHANT_LIGHT8,
  MERCHANT_LIGHT9,
  MERCHANT_LIGHT10,
  MERCHANT_LIGHT11
];

export const SHADOW_COLOR_ONE = '0px 4px 4px rgba(0, 0, 0, 0.08)';
export const SHADOW_COLOR_20 = '0px 4px 4px rgba(0, 0, 0, 0.2)';
export const SHADOW_COLOR_CHARTS = '0px 2px 5px 0px rgba(0, 0, 0, 0.08)';

export const STATUS_LABEL_ARCHIVED = '#717171';

export const STATUS_LABEL_TRANSACTION_APPROVED = '#06814D';
export const STATUS_LABEL_TRANSACTION_PENDING = '#F39200';
export const STATUS_LABEL_TRANSACTION_REJECTED = '#A9080E';
export const STATUS_LABEL_TRANSACTION_ANNULED = '#121212';
export const STATUS_LABEL_TRANSACTION_CANCELED = '#425573';
export const STATUS_LABEL_TRANSACTION_IN_PROCESS = '#06814D';
export const STATUS_LABEL_TRANSACTION_REFUNDED = '#0D3F92';
export const STATUS_LABEL_TRANSACTION_PARTIAL_REFUND = '#0D3F92';

export const OPACITY_BLACK_05 = `${PRIMARY_BLACK}0D`;
export const OPACITY_BLACK_20 = `${PRIMARY_BLACK}32`;
export const OPACITY_BLACK_35 = `${PRIMARY_BLACK}23`;
export const OPACITY_BLACK_80 = `${PRIMARY_BLACK}CC`;
export const OPACITY_WHITE_80 = `${WHITE}CC`;
export const OPACITY_WHITE_70 = `${WHITE}B3`;
export const OPACITY_WHITE_30 = `${WHITE}4D`;
export const OPACITY_WHITE_12 = `${WHITE}1F`;
export const OPACITY_WHITE_00 = `${WHITE}00`;

export const STATUS_PAGE_COLOR_AVAILABLE = '#00D0A6';
export const STATUS_PAGE_COLOR_PARTIAL = '#F39200';
export const STATUS_PAGE_COLOR_TOTAL = '#FE5E5E';
export const STATUS_PAGE_COLOR_MAINTENANCE = '#29C6E2';

export const PRIMARY_PAYMENT_DARK = '#00471B';
export const SECONDARY_PAYMENT_80 = '#58CA8A';
export const STATUS_PROMOTION_LABEL_ACTIVE = PRIMARY_PAYMENT_DEFAULT;
export const STATUS_PROMOTION_LABEL_FINISHED = BLACK;

export const PRIMARY_REWARDS_LIGHT = '#FFF8E5';
